import React, { useEffect, useRef, useState } from 'react';
import '../CSS/Global.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Sidebar from './SideBar';
import { useSidebar } from '../SidebarContext';
import Header from './Header';

function convertToWords(num) {
    num = Number(num);
    if (isNaN(num) || num <= 0) return '';
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
        'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
        'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
        'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numberToWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + numberToWords(n % 100) : "");
        if (n < 100000) return numberToWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + numberToWords(n % 1000) : "");
        if (n < 10000000) return numberToWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + numberToWords(n % 100000) : "");
        return numberToWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + numberToWords(n % 10000000) : "");
    };

    return numberToWords(Number(num));
}


const ResidentPropertyForm = () => {
    const { isSidebarOpen } = useSidebar();
    const [amenities, setAmenities] = useState([]);
    const [watersupply, setWaterSupply] = useState([]);
    const [selectedWaterSupply, setSelectedWaterSupply] = useState([]);
    const [security, setSecurity] = useState([]);
    const [selectedsecurity, setSelectedSecurity] = useState([]);
    const [category, setCategory] = useState([]);
    const [selectedAmenities, setSelectedAmenities] = useState([]);
    const [locationAdvantages, setLocationAdvantages] = useState([]);
    const [selectedLocationAdvantages, setSelectedLocationAdvantages] = useState([]);
    const [availabilityStatus, setAvailabilityStatus] = useState("Ready to Move");
    const fileInputRef = useRef(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [dragging, setDragging] = useState(false);
    const [load, setLoad] = useState(true)
    const scrollContainerRef = useRef(null);
    const url=process.env.REACT_APP_LINK

    const [data, setData] = useState({
        building_name: "",
        address: "",
        city: "",
        floorPlan: "",
        flatType: [],
        carpetArea: [{ carpetArea: "", price: "" }],
        buildupArea: "",
        totalFloors: "",
        floorLevel: "",
        bedrooms: "",
        jodi1: "",
        jodi2: "",
        bathrooms: "",
        balconies: "",
        availability: "",
        ageOfBuilding: "",
        possesionTill: "",
        ownership: "",
        facing: "",
        maintenance: "",
        parking: "",
        securityDeposit: "",
        virtualTour: "",
        furnishStatus: "",
        category: "",
        dev_logo: "",
        developerName: '',
        developerDescription: '',
        propertyDescription: '',
        brokage: '',

        rkCarpetAreas: [{ value: "", showMinus: false }],
        rkBuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
        rkSuperBuiltUpAreas: [{ value: "", showMinus: false }],
        rkExpectedPrices: [{ value: '' }],
        rkBalconies: '',
        rkBathrooms: '',
        rkFurnishStatus: '',
        rkConditionOfFlat: '',
        rkMonthlyMaintenance: '',
        rkPriceAllInclusive: '',
        rkPriceNegotiable: '',
        rkPreferredCashType: [],
        rkLoanFacility: '',
        rkDocumentsAvailable: '',
        rkFloorPlan: '',

        // 1BHK-specific fields
        bhk1CarpetAreas: [{ value: "", showMinus: false }],
        bhk1BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
        bhk1SuperBuiltUpAreas: [{ value: "", showMinus: false }],
        bhk1ExpectedPrices: [{ value: '' }],
        bhk1Bedrooms: '',
        bhk1BedroomsJodi1: '',
        bhk1BedroomsJodi2: '',
        bhk1Balconies: '',
        bhk1Bathrooms: '',
        bhk1FurnishStatus: '',
        bhk1ConditionOfFlat: '',
        bhk1MonthlyMaintenance: '',
        bhk1PriceAllInclusive: '',
        bhk1PriceNegotiable: '',
        bhk1PreferredCashType: [],
        bhk1LoanFacility: '',
        bhk1DocumentsAvailable: '',
        bhk1FloorPlan: '',

        bhk2CarpetAreas: [{ value: "", showMinus: false }],
        bhk2BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
        bhk2SuperBuiltUpAreas: [{ value: "", showMinus: false }],
        bhk2ExpectedPrices: [{ value: '' }],
        bhk2Bedrooms: '',
        bhk2BedroomsJodi1: '',
        bhk2BedroomsJodi2: '',
        bhk2Balconies: '',
        bhk2Bathrooms: '',
        bhk2FurnishStatus: '',
        bhk2ConditionOfFlat: '',
        bhk2MonthlyMaintenance: '',
        bhk2PriceAllInclusive: '',
        bhk2PriceNegotiable: '',
        bhk2PreferredCashType: [],
        bhk2LoanFacility: '',
        bhk2DocumentsAvailable: '',
        bhk2FloorPlan: '',

        bhk3CarpetAreas: [{ value: "", showMinus: false }],
        bhk3BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
        bhk3SuperBuiltUpAreas: [{ value: "", showMinus: false }],
        bhk3ExpectedPrices: [{ value: '' }],
        bhk3Bedrooms: '',
        bhk3BedroomsJodi1: '',
        bhk3BedroomsJodi2: '',
        bhk3Balconies: '',
        bhk3Bathrooms: '',
        bhk3FurnishStatus: '',
        bhk3ConditionOfFlat: '',
        bhk3MonthlyMaintenance: '',
        bhk3PriceAllInclusive: '',
        bhk3PriceNegotiable: '',
        bhk3PreferredCashType: [],
        bhk3LoanFacility: '',
        bhk3DocumentsAvailable: '',
        bhk3FloorPlan: '',

        bhk4CarpetAreas: [{ value: "", showMinus: false }],
        bhk4BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
        bhk4SuperBuiltUpAreas: [{ value: "", showMinus: false }],
        bhk4ExpectedPrices: [{ value: '' }],
        bhk4Bedrooms: '',
        bhk4BedroomsJodi1: '',
        bhk4BedroomsJodi2: '',
        bhk4Balconies: '',
        bhk4Bathrooms: '',
        bhk4FurnishStatus: '',
        bhk4ConditionOfFlat: '',
        bhk4MonthlyMaintenance: '',
        bhk4PriceAllInclusive: '',
        bhk4PriceNegotiable: '',
        bhk4PreferredCashType: [],
        bhk4LoanFacility: '',
        bhk4DocumentsAvailable: '',
        bhk4FloorPlan: '',
        extra1: "",
        extra2: ""
    })
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";

    const navigate = useNavigate();
    const [previews, setPreviews] = useState({
        dev_logo: null,
        bhk4FloorPlan: null,
        bhk3FloorPlan: null,
        bhk2FloorPlan: null,
        bhk1FloorPlan: null,
        rkFloorPlan: null,
    });

    const [errors, setErrors] = useState({
        dev_logo: '',
        bhk4FloorPlan: '',
        bhk3FloorPlan: '',
        bhk2FloorPlan: '',
        bhk1FloorPlan: '',
        rkFloorPlan: '',
    });

    const handleAmenityChange = (event) => {
        const { value } = event.target;
        if (selectedAmenities.includes(value)) {
            setSelectedAmenities(selectedAmenities.filter((item) => item !== value));
        } else {
            setSelectedAmenities([...selectedAmenities, value]);
        }
    };

    const handleLocationAdvantageChange = (event) => {
        const { value } = event.target;
        if (selectedLocationAdvantages.includes(value)) {
            setSelectedLocationAdvantages(
                selectedLocationAdvantages.filter((item) => item !== value)
            );
        } else {
            setSelectedLocationAdvantages([...selectedLocationAdvantages, value]);
        }
    };

    const [showCarpet, setShowCarpet] = useState(false);
    const [showSuperBuiltUp, setShowSuperBuiltUp] = useState(false);
    const [viewBedroomsMore, setViewBedroomsMore] = useState(false);
    const [viewBalconiesMore, setViewBalconiesMore] = useState(false);
    const [viewBathroomsMore, setViewBathroomsMore] = useState(false);
    const [openIndex, setOpenIndex] = useState(null);
    const [superBuiltUpAreas, setSuperBuiltUpAreas] = useState([{ value: "", showMinus: false }]);

    const refs = {
        "1RK": useRef(null),
        "1BHK": useRef(null),
        "2BHK": useRef(null),
        "3BHK": useRef(null),
        "4BHK": useRef(null),
    };

    const handleToggle = (index) => {
        const isOpening = openIndex !== index;
        setOpenIndex(isOpening ? index : null);

        if (isOpening) {
            setTimeout(() => {
                const el = refs[index]?.current;
                if (el) {
                    const offset = 80; // adjust as needed (space above header)
                    const y = el.getBoundingClientRect().top + window.scrollY - offset;
                    window.scrollTo({ top: y, behavior: "smooth" });
                }
            }, 200); // delay to ensure accordion opens before scrolling
        }
    };

    const maxFiles = 20; // Max number of files
    const maxSize = 20 * 1024 * 1024; // 20MB size limit in bytes

    const handleBrowseClick = (event) => {
        event.preventDefault();
        fileInputRef.current.click(); // Trigger the hidden file input
    };

    const formatFileSize = (size) => {
        if (size < 1024) return `${size} B`;
        if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
        return `${(size / (1024 * 1024)).toFixed(2)} MB`;
    };

    const flatTypeFields = {
        "1RK": [
            "rkCarpetAreas", "rkBuiltUpAreas", "rkExpectedPrices", "rkBalconies", "rkBathrooms",
            "rkFurnishStatus", "rkConditionOfFlat", "rkMonthlyMaintenance", "rkPriceAllInclusive", "rkPriceNegotiable",
            "rkPreferredCashType",
        ],
        "1BHK": [
            "bhk1CarpetAreas", "bhk1ExpectedPrices", "bhk1Bedrooms", "bhk1Balconies", "bhk1Bathrooms",
            "bhk1FurnishStatus", "bhk1ConditionOfFlat", "bhk1MonthlyMaintenance", "bhk1PriceAllInclusive",
            "bhk1PriceNegotiable", "bhk1PreferredCashType",
        ],
        "2BHK": [
            "bhk2CarpetAreas", "bhk2ExpectedPrices", "bhk2Bedrooms", "bhk2Balconies", "bhk2Bathrooms",
            "bhk2FurnishStatus", "bhk2ConditionOfFlat", "bhk2MonthlyMaintenance", "bhk2PriceAllInclusive",
            "bhk2PriceNegotiable", "bhk2PreferredCashType",
        ],
        "3BHK": [
            "bhk3CarpetAreas", "bhk3ExpectedPrices", "bhk3Bedrooms", "bhk3Balconies", "bhk3Bathrooms",
            "bhk3FurnishStatus", "bhk3ConditionOfFlat", "bhk3MonthlyMaintenance", "bhk3PriceAllInclusive",
            "bhk3PriceNegotiable", "bhk3PreferredCashType",
        ],
        "4BHK": [
            "bhk4CarpetAreas", "bhk4ExpectedPrices", "bhk4Bedrooms", "bhk4Balconies", "bhk4Bathrooms",
            "bhk4FurnishStatus", "bhk4ConditionOfFlat", "bhk4MonthlyMaintenance", "bhk4PriceAllInclusive",
            "bhk4PriceNegotiable", "bhk4PreferredCashType",
        ]
    };


    const validateFields = () => true;

    const addInput = () => {
        setData((prevData) => ({
            ...prevData,
            carpetArea: [...prevData.carpetArea, { carpetArea: "", price: "" }],
        }));
    };

    const deleteInput = (index) => {
        setData((prevData) => ({
            ...prevData,
            carpetArea: prevData.carpetArea.filter((_, i) => i !== index),
        }));
    };


    const handleDynamicChange = (e, fieldName, index, fieldKey = "value") => {
        const { value } = e.target;

        setData((prevState) => {
            const updatedField = Array.isArray(prevState[fieldName]) // Ensure it's an array
                ? [...prevState[fieldName]]
                : []; // If not, initialize it as an empty array

            // Update the specific field (value or expectedPrice)
            updatedField[index] = {
                ...updatedField[index],
                [fieldKey]: value,
            };

            return {
                ...prevState,
                [fieldName]: updatedField,
            };
        });
    };

    const handleAddField = (fieldName) => {
        setData((prevState) => ({
            ...prevState,
            [fieldName]: [
                ...prevState[fieldName],
                { value: "", expectedPrice: "", showMinus: false },
            ],
        }));
    };

    const handleRemoveField = (fieldName, index) => {
        setData((prevState) => {
            const updatedField = [...prevState[fieldName]];
            updatedField.splice(index, 1); // Remove the field at the given index
            return {
                ...prevState,
                [fieldName]: updatedField,
            };
        });
    };


    const handleEnterPress = (e, type) => {
        if (e.key === "Enter") {
            const value = e.target.value;
            if (Number(value) >= 5) {
                setData((prev) => ({
                    ...prev,
                    [type]: String(value),
                }));
            }
        }
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        const validFiles = files.filter(file =>
            ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(file.type)
        );

        const duplicateFiles = validFiles.filter(file =>
            uploadedFiles.some(existingFile => existingFile.name === file.name)
        );

        if (duplicateFiles.length > 0) {
            toast.error('You cannot upload duplicate images.');
            return;
        }

        if (uploadedFiles.length + validFiles.length > maxFiles) {
            toast.error(`You can upload a maximum of ${maxFiles} images.`);
            return;
        }

        setUploadedFiles(prevFiles => [...prevFiles, ...validFiles]); // store plain File objects
    };



    const handleDeleteFile = (index) => {
        setUploadedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setDragging(true);
    };

    const toggleAmenity = (amenity) => {
        if (selectedAmenities.includes(amenity)) {
            setSelectedAmenities(selectedAmenities.filter((item) => item !== amenity));
        } else {
            setSelectedAmenities([...selectedAmenities, amenity]);
        }
    };

    const toggleLocationAdvantage = (advantage) => {
        if (selectedLocationAdvantages.includes(advantage)) {
            setSelectedLocationAdvantages(
                selectedLocationAdvantages.filter((item) => item !== advantage)
            );
        } else {
            setSelectedLocationAdvantages([...selectedLocationAdvantages, advantage]);
        }
    };

    const toggleWaterSupply = (advantage) => {
        if (selectedWaterSupply.includes(advantage)) {
            setSelectedWaterSupply(
                selectedWaterSupply.filter((item) => item !== advantage)
            );
        } else {
            setSelectedWaterSupply([...selectedWaterSupply, advantage]);
        }
    };

    const toggleSecurity = (advantage) => {
        if (selectedsecurity.includes(advantage)) {
            setSelectedSecurity(
                selectedsecurity.filter((item) => item !== advantage)
            );
        } else {
            setSelectedSecurity([...selectedsecurity, advantage]);
        }
    };

    const handleDragLeave = () => setDragging(false);

    const handleDrop = (event) => {
        event.preventDefault();
        setDragging(false);

        const files = Array.from(event.dataTransfer.files);

        const validFiles = files.filter(file =>
            file.size <= maxSize &&
            ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(file.type)
        );

        const duplicateFiles = validFiles.filter(file =>
            uploadedFiles.some(existingFile => existingFile.name === file.name)
        );

        if (duplicateFiles.length > 0) {
            toast.error('You cannot upload duplicate images.');
            return;
        }

        if (uploadedFiles.length + validFiles.length > maxFiles) {
            toast.error(`You can upload a maximum of ${maxFiles} images.`);
            return;
        }

        setUploadedFiles(prevFiles => [...prevFiles, ...validFiles]);
    };

    const handleRemoveTag = (index, type) => {
        const updatedList = type === 'amenities'
            ? amenities.split(',').filter((_, i) => i !== index).join(',')
            : locationAdvantages.split(',').filter((_, i) => i !== index).join(',');

        type === 'amenities' ? setAmenities(updatedList) : setLocationAdvantages(updatedList);
    };

    const render1RKSection = () => {
        return (
            <div ref={scrollContainerRef} className="accordion-item">
                <div ref={refs["1RK"]} className="accordion-header" onClick={() => handleToggle("1RK")}>
                    <h3>Enter number of 1RK</h3>
                    <span className={openIndex === "1RK" ? 'accordion-icon open' : 'accordion-icon'}>+</span>
                </div>
                {openIndex === "1RK" && (
                    <div className="accordion-body">
                        {/* Built-up Area and Expected Price */}
                        <div className="post-input">
                            <label>Carpet Area (Sq.ft) & Expected Price</label>
                            {data.rkBuiltUpAreas.map((area, index) => (
                                <>
                                    <div key={index} className="carpet-add-remove" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`rkBuiltUpAreas${index}`}
                                                placeholder="Enter Carpet Area"
                                                value={area.value}
                                                onChange={(e) => handleDynamicChange(e, "rkBuiltUpAreas", index, "value")}

                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`rkExpectedPrice${index}`}
                                                placeholder="Enter Expected Price"
                                                value={
                                                    area.expectedPrice && !isNaN(area.expectedPrice)
                                                        ? Number(area.expectedPrice).toLocaleString("en-IN")
                                                        : area.expectedPrice || ""
                                                }
                                                // onChange={(e) => handleDynamicChange(e, "rkBuiltUpAreas", index, "expectedPrice")}
                                                onChange={(e) => {
                                                    const plainNumber = e.target.value.replace(/,/g, '');
                                                    handleDynamicChange({ target: { value: plainNumber } }, "rkBuiltUpAreas", index, "expectedPrice");
                                                }}

                                            />
                                            <small style={{ fontSize: "12px", color: "#007bff", fontWeight: "600" }}>
                                                {area.expectedPrice ? `(${convertToWords(area.expectedPrice)} only)` : ""}
                                            </small>
                                        </div>
                                        <div style={{ marginTop: 10 }}>
                                            {index === data.rkBuiltUpAreas.length - 1 ? (
                                                <i
                                                    className="fa-solid fa-plus"
                                                    onClick={() => handleAddField("rkBuiltUpAreas")}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-minus"
                                                    onClick={() => handleRemoveField("rkBuiltUpAreas", index)}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            )}
                                        </div>
                                    </div>

                                </>
                            ))}
                        </div>

                        <div className="post-input">
                            <label>Balconies</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBalconies"
                                        value="0"
                                        id="balcony-0"
                                        checked={data.rkBalconies === "0"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-0">Without Balcony</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBalconies"
                                        value="1"
                                        id="balcony-1"
                                        checked={data.rkBalconies === "1"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-1">1 Balcony</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBalconies"
                                        value="2"
                                        id="balcony-2"
                                        checked={data.rkBalconies === "2"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-2">2 Balconies</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBalconies"
                                        value="3"
                                        id="balcony-3"
                                        checked={data.rkBalconies === "3"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-3">3 Balconies</label>
                                </div>
                            </div>

                            {!viewBalconiesMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBalconiesMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBalconiesMore && (
                                <div className="number-input">
                                    <label>Enter Number of Balconies</label>
                                    <input
                                        type="text"
                                        name="rkBalconies"
                                        value={data.rkBalconies}
                                        onChange={handleInputChange}
                                        onKeyDown={(e) => handleEnterPress(e, "rkBalconies")}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}
                            {errors.rkBalconies && <span className="error">This field is required*</span>}
                        </div>

                        {/* Bathrooms Section */}
                        <div className="post-input">
                            <label>Bathrooms</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBathrooms"
                                        value="1"
                                        id="bathroom-1"
                                        checked={data.rkBathrooms === "1"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bathroom-1">1 Bathroom</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBathrooms"
                                        value="2"
                                        id="bathroom-2"
                                        checked={data.rkBathrooms === "2"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bathroom-2">2 Bathrooms</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkBathrooms"
                                        value="3"
                                        id="bathroom-3"
                                        checked={data.rkBathrooms === "3"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bathroom-3">3 Bathrooms</label>
                                </div>
                            </div>

                            {!viewBathroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBathroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBathroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bathrooms</label>
                                    <input
                                        type="text"
                                        name="rkBathrooms"
                                        value={data.rkBathrooms}
                                        onChange={handleInputChange}
                                        onKeyDown={(e) => handleEnterPress(e, "rkBathrooms")}
                                        placeholder="Enter custom number"

                                    />
                                </div>
                            )}
                            {errors.rkBathrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Furnish Status Section */}
                        <div className="post-input">
                            <label>Furnish Status</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkFurnishStatus"
                                        value="Furnished"
                                        id="furnish-furnished"
                                        checked={data.rkFurnishStatus === 'Furnished'}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-furnished">Furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkFurnishStatus"
                                        value="Unfurnished"
                                        id="furnish-unfurnished"
                                        checked={data.rkFurnishStatus === 'Unfurnished'}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-unfurnished">Un-furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkFurnishStatus"
                                        value="Semi-furnished"
                                        id="furnish-semi-furnished"
                                        checked={data.rkFurnishStatus === 'Semi-furnished'}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-semi-furnished">Semi-furnished</label>
                                </div>
                            </div>
                            {errors.rkFurnishStatus && <span className="error">This field is required*</span>}
                        </div>

                        {/* Condition of Flat Section */}
                        <div className="post-input">
                            <label>Condition of Flat</label>
                            <input
                                type="text"
                                name="rkConditionOfFlat"
                                value={data.rkConditionOfFlat}
                                onChange={handleInputChange}
                                placeholder="Enter condition of flat (Maintenance/Repair)"
                            />
                            {errors.rkConditionOfFlat && <span className="error">This field is required*</span>}
                        </div>


                        {/* Monthly Maintenance Section */}
                        <div className="post-input">
                            <label>Monthly Maintenance</label>
                            <input
                                type="text"
                                name="rkMonthlyMaintenance"
                                placeholder="Enter Monthly Maintenance"
                                value={data.rkMonthlyMaintenance}
                                onChange={handleInputChange}
                            />
                            {errors.rkMonthlyMaintenance && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price All Inclusive Section */}
                        <div className="post-input">
                            <label>Price all inclusive</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkPriceAllInclusive"
                                        value="Yes"
                                        id="price-all-inclusive-yes"
                                        checked={data.rkPriceAllInclusive === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkPriceAllInclusive"
                                        value="No"
                                        id="price-all-inclusive-no"
                                        checked={data.rkPriceAllInclusive === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-no">No</label>
                                </div>
                            </div>
                            {errors.rkPriceAllInclusive && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable Section */}
                        <div className="post-input">
                            <label>Price Negotiable</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkPriceNegotiable"
                                        value="Yes"
                                        id="price-negotiable-yes"
                                        checked={data.rkPriceNegotiable === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="rkPriceNegotiable"
                                        value="No"
                                        id="price-negotiable-no"
                                        checked={data.rkPriceNegotiable === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-no">No</label>
                                </div>
                            </div>
                            {errors.rkPriceNegotiable && <span className="error">This field is required*</span>}
                        </div>

                        {/* Preferred Cash Type Section */}
                        <div className="post-input">
                            <label>Preferred Cash Type</label>
                            <div className="checkbox-group">
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="rkPreferredCashType"
                                        value="Cash"
                                        id="cash-type-cash"
                                        checked={data.rkPreferredCashType.includes("Cash")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cash">Cash</label>
                                </div>
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="rkPreferredCashType"
                                        value="Cheque"
                                        id="cash-type-cheque"
                                        checked={data.rkPreferredCashType.includes("Cheque")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cheque">Cheque</label>
                                </div>
                            </div>
                            {errors.rkPreferredCashType && <span className="error">This field is required*</span>}
                        </div>

                        {/* Loan Facility Section */}
                        <div className="post-input">
                            <label>Loan Facility</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        id="loan-available"
                                        type="radio"
                                        name="rkLoanFacility"
                                        value="Available"
                                        checked={data.rkLoanFacility === "Available"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="loan-available">Available</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        id="loan-notavailable"
                                        type="radio"
                                        name="rkLoanFacility"
                                        value="Not Available"
                                        checked={data.rkLoanFacility === "Not Available"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="loan-notavailable">Not Available</label>
                                </div>
                            </div>
                            {errors.rkLoanFacility && <span className="error">This field is required*</span>}
                        </div>

                        {/* Are Property Documents Available Section */}

                        <div className="post-input">
                            <label>Floor plan</label>
                            <input
                                type="file"
                                name="rkFloorPlan"
                                accept="image/*"
                                onChange={handleInputChange}
                            />
                            {previews.rkFloorPlan && (
                                <div className="image-preview">
                                    <img
                                        src={previews.rkFloorPlan}
                                        alt="RK Floor Plan Preview"
                                        style={{ maxWidth: "150px", marginTop: "10px" }}
                                    />
                                </div>
                            )}
                            {errors.rkFloorPlan && <span className="error">{errors.rkFloorPlan}</span>}
                        </div>

                    </div>
                )}
            </div>
        );
    };

    // 4BHK section
    const render1BHKSection = () => {
        return (
            <div ref={scrollContainerRef} className="accordion-item">
                <div ref={refs["1BHK"]} className="accordion-header" onClick={() => handleToggle("1BHK")}>
                    <h3>Enter number of 1BHK</h3>
                    <span className={openIndex === "1BHK" ? 'accordion-icon open' : 'accordion-icon'}>+</span>
                </div>
                {openIndex === "1BHK" && (
                    <div className="accordion-body">
                        {/* Built-up Area and Expected Price */}
                        <div className="post-input">
                            <label>Carpet Area (Sq.ft) & Expected Price</label>
                            {data.bhk1BuiltUpAreas.map((area, index) => (
                                <>
                                    <div key={index} className="carpet-add-remove" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`bhk1BuiltUpAreas${index}`}
                                                placeholder="Enter Carpet Area"
                                                value={area.value}
                                                onChange={(e) => handleDynamicChange(e, "bhk1BuiltUpAreas", index, "value")}

                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`bhk1ExpectedPrice${index}`}
                                                placeholder="Enter Expected Price"
                                                value={
                                                    area.expectedPrice && !isNaN(area.expectedPrice)
                                                        ? Number(area.expectedPrice).toLocaleString("en-IN")
                                                        : area.expectedPrice || ""
                                                }

                                                // onChange={(e) => handleDynamicChange(e, "bhk1BuiltUpAreas", index, "expectedPrice")}
                                                onChange={(e) => {
                                                    const plainNumber = e.target.value.replace(/,/g, '');
                                                    handleDynamicChange({ target: { value: plainNumber } }, "bhk1BuiltUpAreas", index, "expectedPrice");
                                                }}

                                            />
                                            <small style={{ fontSize: "12px", color: "#007bff", fontWeight: "600" }}>
                                                {area.expectedPrice ? `(${convertToWords(area.expectedPrice)} only)` : ""}
                                            </small>
                                        </div>
                                        <div style={{ marginTop: 10 }}>
                                            {index === data.bhk1BuiltUpAreas.length - 1 ? (
                                                <i
                                                    className="fa-solid fa-plus"
                                                    onClick={() => {
                                                        handleAddField("bhk1BuiltUpAreas");
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-minus"
                                                    onClick={() => {
                                                        handleRemoveField("bhk1BuiltUpAreas", index);
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            )}
                                        </div>
                                    </div>

                                </>
                            ))}
                        </div>
                        <div className="post-input">
                            <label>Bedrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3, 4].map((num) => (
                                    <div className="radio-option" key={`bedroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk1Bedrooms"
                                            value={num}
                                            id={`bedroom-${num}`}
                                            checked={data.bhk1Bedrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bedroom-${num}`}>{num} Bedroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}

                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1Bedrooms"
                                        value="jodi"
                                        id="bedroom-jodi"
                                        checked={data.bhk1Bedrooms === "jodi"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bedroom-jodi">Jodi</label>
                                </div>
                            </div>

                            {/* Jodi Input Fields */}
                            {data.bhk1Bedrooms === "jodi" && (
                                <div className="jodi-bedroom-inputs">
                                    <label>Enter Jodi Bedrooms</label>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <input
                                            type="number"
                                            name="bhk1BedroomsJodi1"
                                            value={data.bhk1BedroomsJodi1 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 1"
                                            style={{ width: "100px" }}
                                        />
                                        <span>+</span>
                                        <input
                                            type="number"
                                            name="bhk1BedroomsJodi2"
                                            value={data.bhk1BedroomsJodi2 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 2"
                                            style={{ width: "100px" }}
                                        />
                                    </div>
                                </div>
                            )}

                            {/* View More (Hidden if Jodi is selected) */}
                            {data.bhk1Bedrooms !== "jodi" && !viewBedroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBedroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {data.bhk1Bedrooms !== "jodi" && viewBedroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bedrooms</label>
                                    <input
                                        type="text"
                                        name="bhk1Bedrooms"
                                        value={data.bhk1Bedrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}

                            {errors.bhk1Bedrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Balconies Section */}
                        <div className="post-input">
                            <label>Balconies</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1Balconies"
                                        value="0"
                                        id="balcony-0"
                                        checked={data.bhk1Balconies === "0"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-0">Without Balcony</label>
                                </div>

                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`balcony-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk1Balconies"
                                            value={num}
                                            id={`balcony-${num}`}
                                            checked={data.bhk1Balconies === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`balcony-${num}`}>{num} Balcony{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBalconiesMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBalconiesMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBalconiesMore && (
                                <div className="number-input">
                                    <label>Enter Number of Balconies</label>
                                    <input
                                        type="text"
                                        name="bhk1Balconies"
                                        value={data.bhk1Balconies}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}
                            {errors.bhk1Balconies && <span className="error">This field is required*</span>}
                        </div>

                        {/* Bathrooms Section */}
                        <div className="post-input">
                            <label>Bathrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`bathroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk1Bathrooms"
                                            value={num}
                                            id={`bathroom-${num}`}
                                            checked={data.bhk1Bathrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bathroom-${num}`}>{num} Bathroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBathroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBathroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBathroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bathrooms</label>
                                    <input
                                        type="text"
                                        name="bhk1Bathrooms"
                                        value={data.bhk1Bathrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"

                                    />
                                </div>
                            )}
                            {errors.bhk1Bathrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Furnish Status */}
                        <div className="post-input">
                            <label>Furnish Status</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1FurnishStatus"
                                        value="Furnished"
                                        id="furnish-furnished"
                                        checked={data.bhk1FurnishStatus === "Furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-furnished">Furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1FurnishStatus"
                                        value="Unfurnished"
                                        id="furnish-unfurnished"
                                        checked={data.bhk1FurnishStatus === "Unfurnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-unfurnished">Un-furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1FurnishStatus"
                                        value="Semi-furnished"
                                        id="furnish-semi-furnished"
                                        checked={data.bhk1FurnishStatus === "Semi-furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-semi-furnished">Semi-furnished</label>
                                </div>
                            </div>
                            {errors.bhk1FurnishStatus && <span className="error">This field is required*</span>}
                        </div>

                        {/* Condition of Flat */}
                        <div className="post-input">
                            <label>Condition of Flat</label>
                            <input
                                type="text"
                                name="bhk1ConditionOfFlat"
                                value={data.bhk1ConditionOfFlat}
                                onChange={handleInputChange}
                                placeholder="Enter condition of flat (Maintenance/Repair)"
                            />
                            {errors.bhk1ConditionOfFlat && <span className="error">This field is required*</span>}
                        </div>

                        {/* Monthly Maintenance */}
                        <div className="post-input">
                            <label>Monthly Maintenance</label>
                            <input
                                type="text"
                                name="bhk1MonthlyMaintenance"
                                value={data.bhk1MonthlyMaintenance}
                                onChange={handleInputChange}
                                placeholder="Enter Monthly Maintenance"
                            />
                            {errors.bhk1MonthlyMaintenance && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price all inclusive</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1PriceAllInclusive"
                                        value="Yes"
                                        id="price-all-inclusive-yes"
                                        checked={data.bhk1PriceAllInclusive === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1PriceAllInclusive"
                                        value="No"
                                        id="price-all-inclusive-no"
                                        checked={data.bhk1PriceAllInclusive === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-no">No</label>
                                </div>
                            </div>
                            {errors.bhk1PriceAllInclusive && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price Negotiable</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1PriceNegotiable"
                                        value="Yes"
                                        id="price-negotiable-yes"
                                        checked={data.bhk1PriceNegotiable === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk1PriceNegotiable"
                                        value="No"
                                        id="price-negotiable-no"
                                        checked={data.bhk1PriceNegotiable === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-no">No</label>
                                </div>
                            </div>
                            {errors.bhk1PriceNegotiable && <span className="error">This field is required*</span>}
                        </div>

                        {/* Preferred Cash Type */}
                        <div className="post-input">
                            <label>Preferred Cash Type</label>
                            <div className="checkbox-group">
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk1PreferredCashType"
                                        value="Cash"
                                        id="cash-type-cash"
                                        checked={data.bhk1PreferredCashType.includes("Cash")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cash">Cash</label>
                                </div>
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk1PreferredCashType"
                                        value="Cheque"
                                        id="cash-type-cheque"
                                        checked={data.bhk1PreferredCashType.includes("Cheque")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cheque">Cheque</label>
                                </div>
                            </div>
                            {errors.bhk1PreferredCashType && <span className="error">This field is required*</span>}
                        </div>


                        <div className="post-input">
                            <label>Floor plan</label>
                            <input
                                type="file"
                                name="bhk1FloorPlan"
                                accept="image/*"
                                onChange={handleInputChange}
                            />
                            {previews.bhk1FloorPlan && (
                                <div className="image-preview">
                                    <img
                                        src={previews.bhk1FloorPlan}
                                        alt="BHK1 Floor Plan Preview"
                                        style={{ maxWidth: "150px", marginTop: "10px" }}
                                    />
                                </div>
                            )}
                            {errors.bhk1FloorPlan && <span className="error">{errors.bhk1FloorPlan}</span>}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // 2BHK section
    const render2BHKSection = () => {
        return (
            <div ref={scrollContainerRef} className="accordion-item">
                <div ref={refs["2BHK"]} className="accordion-header" onClick={() => handleToggle("2BHK")}>
                    <h3>Enter number of 2BHK</h3>
                    <span className={openIndex === "2BHK" ? 'accordion-icon open' : 'accordion-icon'}>+</span>
                </div>
                {openIndex === "2BHK" && (
                    <div className="accordion-body">
                        {/* Built-up Area and Expected Price */}
                        <div className="post-input">
                            <label>Carpet Area (Sq.ft) & Expected Price</label>
                            {data.bhk2BuiltUpAreas.map((area, index) => (
                                <>
                                    <div key={index} className="carpet-add-remove" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`bhk2BuiltUpAreas${index}`}
                                                placeholder="Enter Carpet Area"
                                                value={area.value}
                                                onChange={(e) => handleDynamicChange(e, "bhk2BuiltUpAreas", index, "value")}

                                            />
                                        </div>
                                        {/* <input
                                        type="text"
                                        name={`bhk2ExpectedPrice${index}`}
                                        placeholder="Enter Expected Price"
                                        value={area.expectedPrice || ""}

                                        onChange={(e) => handleDynamicChange(e, "bhk2BuiltUpAreas", index, "expectedPrice")}
                                        style={{ flex: 1 }}
                                    /> */}
                                        {/* <div style={{ flex: 1 }}> */}
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`bhk2ExpectedPrice${index}`}
                                                placeholder="Enter Expected Price"
                                                value={
                                                    area.expectedPrice && !isNaN(area.expectedPrice)
                                                        ? Number(area.expectedPrice).toLocaleString("en-IN")
                                                        : area.expectedPrice || ""
                                                }
                                                onChange={(e) => {
                                                    const plainNumber = e.target.value.replace(/,/g, '');
                                                    handleDynamicChange({ target: { value: plainNumber } }, "bhk2BuiltUpAreas", index, "expectedPrice");
                                                }}


                                            />
                                            <small style={{ fontSize: "12px", color: "#007bff", fontWeight: "600" }}>
                                                {area.expectedPrice ? `(${convertToWords(area.expectedPrice)} only)` : ""}
                                            </small>
                                        </div>

                                        {/* </div> */}

                                        <div style={{ marginTop: 10 }}>
                                            {index === data.bhk2BuiltUpAreas.length - 1 ? (
                                                <i
                                                    className="fa-solid fa-plus"
                                                    onClick={() => {
                                                        handleAddField("bhk2BuiltUpAreas");
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-minus"
                                                    onClick={() => {
                                                        handleRemoveField("bhk2BuiltUpAreas", index);
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            )}
                                        </div>

                                    </div>

                                </>
                            ))}
                        </div>


                        {/* Bedrooms Section */}
                        <div className="post-input">
                            <label>Bedrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3, 4].map((num) => (
                                    <div className="radio-option" key={`bedroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk2Bedrooms"
                                            value={num}
                                            id={`bedroom-${num}`}
                                            checked={data.bhk2Bedrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bedroom-${num}`}>{num} Bedroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}

                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2Bedrooms"
                                        value="jodi"
                                        id="bedroom-jodi"
                                        checked={data.bhk2Bedrooms === "jodi"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bedroom-jodi">Jodi</label>
                                </div>
                            </div>

                            {/* Jodi Input Fields */}
                            {data.bhk2Bedrooms === "jodi" && (
                                <div className="jodi-bedroom-inputs">
                                    <label>Enter Jodi Bedrooms</label>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <input
                                            type="number"
                                            name="bhk2BedroomsJodi1"
                                            value={data.bhk2BedroomsJodi1 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 1"
                                            style={{ width: "100px" }}
                                        />
                                        <span>+</span>
                                        <input
                                            type="number"
                                            name="bhk2BedroomsJodi2"
                                            value={data.bhk2BedroomsJodi2 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 2"
                                            style={{ width: "100px" }}
                                        />
                                    </div>
                                </div>
                            )}

                            {/* View More (Hidden if Jodi is selected) */}
                            {data.bhk2Bedrooms !== "jodi" && !viewBedroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBedroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {data.bhk2Bedrooms !== "jodi" && viewBedroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bedrooms</label>
                                    <input
                                        type="text"
                                        name="bhk2Bedrooms"
                                        value={data.bhk2Bedrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}

                            {errors.bhk2Bedrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Balconies Section */}
                        <div className="post-input">
                            <label>Balconies</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2Balconies"
                                        value="0"
                                        id="balcony-0"
                                        checked={data.bhk2Balconies === "0"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-0">Without Balcony</label>
                                </div>

                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`balcony-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk2Balconies"
                                            value={num}
                                            id={`balcony-${num}`}
                                            checked={data.bhk2Balconies === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`balcony-${num}`}>{num} Balcony{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBalconiesMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBalconiesMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBalconiesMore && (
                                <div className="number-input">
                                    <label>Enter Number of Balconies</label>
                                    <input
                                        type="text"
                                        name="bhk2Balconies"
                                        value={data.bhk2Balconies}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}
                            {errors.bhk2Balconies && <span className="error">This field is required*</span>}
                        </div>

                        {/* Bathrooms Section */}
                        <div className="post-input">
                            <label>Bathrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`bathroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk2Bathrooms"
                                            value={num}
                                            id={`bathroom-${num}`}
                                            checked={data.bhk2Bathrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bathroom-${num}`}>{num} Bathroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBathroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBathroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBathroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bathrooms</label>
                                    <input
                                        type="text"
                                        name="bhk2Bathrooms"
                                        value={data.bhk2Bathrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    // min="5"
                                    />
                                </div>
                            )}
                            {errors.bhk2Bathrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Furnish Status */}
                        <div className="post-input">
                            <label>Furnish Status</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2FurnishStatus"
                                        value="Furnished"
                                        id="furnish-furnished"
                                        checked={data.bhk2FurnishStatus === "Furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-furnished">Furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2FurnishStatus"
                                        value="Unfurnished"
                                        id="furnish-unfurnished"
                                        checked={data.bhk2FurnishStatus === "Unfurnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-unfurnished">Un-furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2FurnishStatus"
                                        value="Semi-furnished"
                                        id="furnish-semi-furnished"
                                        checked={data.bhk2FurnishStatus === "Semi-furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-semi-furnished">Semi-furnished</label>
                                </div>
                            </div>
                            {errors.bhk2FurnishStatus && <span className="error">This field is required*</span>}
                        </div>

                        {/* Condition of Flat */}
                        <div className="post-input">
                            <label>Condition of Flat</label>
                            <input
                                type="text"
                                name="bhk2ConditionOfFlat"
                                value={data.bhk2ConditionOfFlat}
                                onChange={handleInputChange}
                                placeholder="Enter condition of flat (Maintenance/Repair)"
                            />
                            {errors.bhk2ConditionOfFlat && <span className="error">This field is required*</span>}
                        </div>


                        {/* Monthly Maintenance */}
                        <div className="post-input">
                            <label>Monthly Maintenance</label>
                            <input
                                type="text"
                                name="bhk2MonthlyMaintenance"
                                value={data.bhk2MonthlyMaintenance}
                                onChange={handleInputChange}
                                placeholder="Enter Monthly Maintenance"
                            />
                            {errors.bhk2MonthlyMaintenance && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price all inclusive</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2PriceAllInclusive"
                                        value="Yes"
                                        id="price-all-inclusive-yes"
                                        checked={data.bhk2PriceAllInclusive === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2PriceAllInclusive"
                                        value="No"
                                        id="price-all-inclusive-no"
                                        checked={data.bhk2PriceAllInclusive === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-no">No</label>
                                </div>
                            </div>
                            {errors.bhk2PriceAllInclusive && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price Negotiable</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2PriceNegotiable"
                                        value="Yes"
                                        id="price-negotiable-yes"
                                        checked={data.bhk2PriceNegotiable === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk2PriceNegotiable"
                                        value="No"
                                        id="price-negotiable-no"
                                        checked={data.bhk2PriceNegotiable === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-no">No</label>
                                </div>
                            </div>
                            {errors.bhk2PriceNegotiable && <span className="error">This field is required*</span>}
                        </div>

                        {/* Preferred Cash Type */}
                        <div className="post-input">
                            <label>Preferred Cash Type</label>
                            <div className="checkbox-group">
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk2PreferredCashType"
                                        value="Cash"
                                        id="cash-type-cash"
                                        checked={data.bhk2PreferredCashType.includes("Cash")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cash">Cash</label>
                                </div>
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk2PreferredCashType"
                                        value="Cheque"
                                        id="cash-type-cheque"
                                        checked={data.bhk2PreferredCashType.includes("Cheque")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cheque">Cheque</label>
                                </div>
                            </div>
                            {errors.bhk2PreferredCashType && <span className="error">This field is required*</span>}
                        </div>


                        <div className="post-input">
                            <label>Floor plan</label>
                            <input
                                type="file"
                                name="bhk2FloorPlan"
                                accept="image/*"
                                onChange={handleInputChange}
                            />
                            {previews.bhk2FloorPlan && (
                                <div className="image-preview">
                                    <img
                                        src={previews.bhk2FloorPlan}
                                        alt="BHK2 Floor Plan Preview"
                                        style={{ maxWidth: "150px", marginTop: "10px" }}
                                    />
                                </div>
                            )}
                            {errors.bhk2FloorPlan && <span className="error">{errors.bhk2FloorPlan}</span>}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // 3BHK section
    const render3BHKSection = () => {
        return (
            <div ref={scrollContainerRef} className="accordion-item">
                <div ref={refs["3BHK"]} className="accordion-header" onClick={() => handleToggle("3BHK")}>
                    <h3>Enter number of 3BHK</h3>
                    <span className={openIndex === "3BHK" ? 'accordion-icon open' : 'accordion-icon'}>+</span>
                </div>
                {openIndex === "3BHK" && (
                    <div className="accordion-body">
                        {/* Built-up Area and Expected Price */}
                        <div className="post-input">
                            <label>Carpet Area (Sq.ft) & Expected Price</label>
                            {data.bhk3BuiltUpAreas.map((area, index) => (
                                <>
                                    <div key={index} className="carpet-add-remove" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`bhk3BuiltUpAreas${index}`}
                                                placeholder="Enter Carpet Area"
                                                value={area.value}
                                                onChange={(e) => handleDynamicChange(e, "bhk3BuiltUpAreas", index, "value")}

                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`bhk3ExpectedPrice${index}`}
                                                placeholder="Enter Expected Price"
                                                value={
                                                    area.expectedPrice && !isNaN(area.expectedPrice)
                                                        ? Number(area.expectedPrice).toLocaleString("en-IN")
                                                        : area.expectedPrice || ""
                                                }
                                                // onChange={(e) => handleDynamicChange(e, "bhk3BuiltUpAreas", index, "expectedPrice")}
                                                onChange={(e) => {
                                                    const plainNumber = e.target.value.replace(/,/g, '');
                                                    handleDynamicChange({ target: { value: plainNumber } }, "bhk3BuiltUpAreas", index, "expectedPrice");
                                                }}


                                            />
                                            <small style={{ fontSize: "12px", color: "#007bff", fontWeight: "600" }}>
                                                {area.expectedPrice ? `(${convertToWords(area.expectedPrice)} only)` : ""}
                                            </small>
                                        </div>
                                        <div style={{ marginTop: 10 }}>
                                            {index === data.bhk3BuiltUpAreas.length - 1 ? (
                                                <i
                                                    className="fa-solid fa-plus"
                                                    onClick={() => {
                                                        handleAddField("bhk3BuiltUpAreas");
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-minus"
                                                    onClick={() => {
                                                        handleRemoveField("bhk3BuiltUpAreas", index);
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            )}
                                        </div>
                                    </div>

                                </>
                            ))}
                        </div>


                        {/* Bedrooms Section */}
                        <div className="post-input">
                            <label>Bedrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3, 4].map((num) => (
                                    <div className="radio-option" key={`bedroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk3Bedrooms"
                                            value={num}
                                            id={`bedroom-${num}`}
                                            checked={data.bhk3Bedrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bedroom-${num}`}>{num} Bedroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}

                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3Bedrooms"
                                        value="jodi"
                                        id="bedroom-jodi"
                                        checked={data.bhk3Bedrooms === "jodi"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bedroom-jodi">Jodi</label>
                                </div>
                            </div>

                            {/* Jodi Input Fields */}
                            {data.bhk3Bedrooms === "jodi" && (
                                <div className="jodi-bedroom-inputs">
                                    <label>Enter Jodi Bedrooms</label>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <input
                                            type="number"
                                            name="bhk3BedroomsJodi1"
                                            value={data.bhk3BedroomsJodi1 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 1"
                                            style={{ width: "100px" }}
                                        />
                                        <span>+</span>
                                        <input
                                            type="number"
                                            name="bhk3BedroomsJodi2"
                                            value={data.bhk3BedroomsJodi2 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 2"
                                            style={{ width: "100px" }}
                                        />
                                    </div>
                                </div>
                            )}

                            {/* View More (Hidden if Jodi is selected) */}
                            {data.bhk3Bedrooms !== "jodi" && !viewBedroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBedroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {data.bhk3Bedrooms !== "jodi" && viewBedroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bedrooms</label>
                                    <input
                                        type="text"
                                        name="bhk3Bedrooms"
                                        value={data.bhk3Bedrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}

                            {errors.bhk3Bedrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Balconies Section */}
                        <div className="post-input">
                            <label>Balconies</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3Balconies"
                                        value="0"
                                        id="balcony-0"
                                        checked={data.bhk3Balconies === "0"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-0">Without Balcony</label>
                                </div>

                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`balcony-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk3Balconies"
                                            value={num}
                                            id={`balcony-${num}`}
                                            checked={data.bhk3Balconies === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`balcony-${num}`}>{num} Balcony{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBalconiesMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBalconiesMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBalconiesMore && (
                                <div className="number-input">
                                    <label>Enter Number of Balconies</label>
                                    <input
                                        type="text"
                                        name="bhk3Balconies"
                                        value={data.bhk3Balconies}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}
                            {errors.bhk3Balconies && <span className="error">This field is required*</span>}
                        </div>

                        {/* Bathrooms Section */}
                        <div className="post-input">
                            <label>Bathrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`bathroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk3Bathrooms"
                                            value={num}
                                            id={`bathroom-${num}`}
                                            checked={data.bhk3Bathrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bathroom-${num}`}>{num} Bathroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBathroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBathroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBathroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bathrooms</label>
                                    <input
                                        type="text"
                                        name="bhk3Bathrooms"
                                        value={data.bhk3Bathrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    // min="5"
                                    />
                                </div>
                            )}
                            {errors.bhk3Bathrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Furnish Status */}
                        <div className="post-input">
                            <label>Furnish Status</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3FurnishStatus"
                                        value="Furnished"
                                        id="furnish-furnished"
                                        checked={data.bhk3FurnishStatus === "Furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-furnished">Furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3FurnishStatus"
                                        value="Unfurnished"
                                        id="furnish-unfurnished"
                                        checked={data.bhk3FurnishStatus === "Unfurnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-unfurnished">Un-furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3FurnishStatus"
                                        value="Semi-furnished"
                                        id="furnish-semi-furnished"
                                        checked={data.bhk3FurnishStatus === "Semi-furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-semi-furnished">Semi-furnished</label>
                                </div>
                            </div>
                            {errors.bhk3FurnishStatus && <span className="error">This field is required*</span>}
                        </div>

                        {/* Condition of Flat */}
                        <div className="post-input">
                            <label>Condition of Flat</label>
                            <input
                                type="text"
                                name="bhk3ConditionOfFlat"
                                value={data.bhk3ConditionOfFlat}
                                onChange={handleInputChange}
                                placeholder="Enter condition of flat (Maintenance/Repair)"
                            />
                            {errors.bhk3ConditionOfFlat && <span className="error">This field is required*</span>}
                        </div>


                        {/* Monthly Maintenance */}
                        <div className="post-input">
                            <label>Monthly Maintenance</label>
                            <input
                                type="text"
                                name="bhk3MonthlyMaintenance"
                                value={data.bhk3MonthlyMaintenance}
                                onChange={handleInputChange}
                                placeholder="Enter Monthly Maintenance"
                            />
                            {errors.bhk3MonthlyMaintenance && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price all inclusive</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3PriceAllInclusive"
                                        value="Yes"
                                        id="price-all-inclusive-yes"
                                        checked={data.bhk3PriceAllInclusive === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3PriceAllInclusive"
                                        value="No"
                                        id="price-all-inclusive-no"
                                        checked={data.bhk3PriceAllInclusive === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-no">No</label>
                                </div>
                            </div>
                            {errors.bhk3PriceAllInclusive && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price Negotiable</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3PriceNegotiable"
                                        value="Yes"
                                        id="price-negotiable-yes"
                                        checked={data.bhk3PriceNegotiable === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk3PriceNegotiable"
                                        value="No"
                                        id="price-negotiable-no"
                                        checked={data.bhk3PriceNegotiable === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-no">No</label>
                                </div>
                            </div>
                            {errors.bhk3PriceNegotiable && <span className="error">This field is required*</span>}
                        </div>

                        {/* Preferred Cash Type */}
                        <div className="post-input">
                            <label>Preferred Cash Type</label>
                            <div className="checkbox-group">
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk3PreferredCashType"
                                        value="Cash"
                                        id="cash-type-cash"
                                        checked={data.bhk3PreferredCashType.includes("Cash")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cash">Cash</label>
                                </div>
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk3PreferredCashType"
                                        value="Cheque"
                                        id="cash-type-cheque"
                                        checked={data.bhk3PreferredCashType.includes("Cheque")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cheque">Cheque</label>
                                </div>
                            </div>
                            {errors.bhk3PreferredCashType && <span className="error">This field is required*</span>}
                        </div>


                        <div className="post-input">
                            <label>Floor plan</label>
                            <input
                                type="file"
                                name="bhk3FloorPlan"
                                accept="image/*"
                                onChange={handleInputChange}
                            />
                            {previews.bhk3FloorPlan && (
                                <div className="image-preview">
                                    <img
                                        src={previews.bhk3FloorPlan}
                                        alt="BHK3 Floor Plan Preview"
                                        style={{ maxWidth: "150px", marginTop: "10px" }}
                                    />
                                </div>
                            )}
                            {errors.bhk3FloorPlan && <span className="error">{errors.bhk3FloorPlan}</span>}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // 4BHK section
    const render4BHKSection = () => {
        return (
            <div ref={scrollContainerRef} className="accordion-item">
                <div ref={refs["4BHK"]} className="accordion-header" onClick={() => handleToggle("4BHK")}>
                    <h3>Enter number of 4BHK</h3>
                    <span className={openIndex === "4BHK" ? 'accordion-icon open' : 'accordion-icon'}>+</span>
                </div>
                {openIndex === "4BHK" && (
                    <div className="accordion-body">
                        {/* Built-up Area and Expected Price */}
                        <div className="post-input">
                            <label> Carpet Area (Sq.ft) & Expected Price</label>
                            {data.bhk4BuiltUpAreas.map((area, index) => (
                                <>
                                    <div key={index} className="carpet-add-remove" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`bhk4BuiltUpAreas${index}`}
                                                placeholder="Enter Carpet Area"
                                                value={area.value}
                                                onChange={(e) => handleDynamicChange(e, "bhk4BuiltUpAreas", index, "value")}

                                            />
                                        </div>
                                        <div style={{ flex: 1 }}>
                                            <input
                                                type="text"
                                                name={`bhk4ExpectedPrice${index}`}
                                                placeholder="Enter Expected Price"
                                                value={
                                                    area.expectedPrice && !isNaN(area.expectedPrice)
                                                        ? Number(area.expectedPrice).toLocaleString("en-IN")
                                                        : area.expectedPrice || ""
                                                }
                                                // onChange={(e) => handleDynamicChange(e, "bhk4BuiltUpAreas", index, "expectedPrice")}
                                                onChange={(e) => {
                                                    const plainNumber = e.target.value.replace(/,/g, '');
                                                    handleDynamicChange({ target: { value: plainNumber } }, "bhk4BuiltUpAreas", index, "expectedPrice");
                                                }}

                                            />
                                            <small style={{ fontSize: "12px", color: "#007bff", fontWeight: "600" }}>
                                                {area.expectedPrice ? `(${convertToWords(area.expectedPrice)} only)` : ""}
                                            </small>
                                        </div>
                                        <div style={{ marginTop: 10 }}>
                                            {index === data.bhk4BuiltUpAreas.length - 1 ? (
                                                <i
                                                    className="fa-solid fa-plus"
                                                    onClick={() => {
                                                        handleAddField("bhk4BuiltUpAreas");
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-minus"
                                                    onClick={() => {
                                                        handleRemoveField("bhk4BuiltUpAreas", index);
                                                    }}
                                                    style={{ cursor: 'pointer' }}
                                                ></i>
                                            )}
                                        </div>
                                    </div>

                                </>
                            ))}
                        </div>
                        {/* Carpet Area Toggle */}


                        {/* Bedrooms Section */}
                        <div className="post-input">
                            <label>Bedrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3, 4].map((num) => (
                                    <div className="radio-option" key={`bedroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk4Bedrooms"
                                            value={num}
                                            id={`bedroom-${num}`}
                                            checked={data.bhk4Bedrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bedroom-${num}`}>{num} Bedroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}

                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4Bedrooms"
                                        value="jodi"
                                        id="bedroom-jodi"
                                        checked={data.bhk4Bedrooms === "jodi"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="bedroom-jodi">Jodi</label>
                                </div>
                            </div>

                            {/* Jodi Input Fields */}
                            {data.bhk4Bedrooms === "jodi" && (
                                <div className="jodi-bedroom-inputs">
                                    <label>Enter Jodi Bedrooms</label>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <input
                                            type="number"
                                            name="bhk4BedroomsJodi1"
                                            value={data.bhk4BedroomsJodi1 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 1"
                                            style={{ width: "100px" }}
                                        />
                                        <span>+</span>
                                        <input
                                            type="number"
                                            name="bhk4BedroomsJodi2"
                                            value={data.bhk4BedroomsJodi2 || ""}
                                            onChange={handleInputChange}
                                            placeholder="e.g. 2"
                                            style={{ width: "100px" }}
                                        />
                                    </div>
                                </div>
                            )}

                            {/* View More (Hidden if Jodi is selected) */}
                            {data.bhk4Bedrooms !== "jodi" && !viewBedroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBedroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {data.bhk4Bedrooms !== "jodi" && viewBedroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bedrooms</label>
                                    <input
                                        type="text"
                                        name="bhk4Bedrooms"
                                        value={data.bhk4Bedrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}

                            {errors.bhk4Bedrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Balconies Section */}
                        <div className="post-input">
                            <label>Balconies</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4Balconies"
                                        value="0"
                                        id="balcony-0"
                                        checked={data.bhk4Balconies === "0"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="balcony-0">Without Balcony</label>
                                </div>

                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`balcony-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk4Balconies"
                                            value={num}
                                            id={`balcony-${num}`}
                                            checked={data.bhk4Balconies === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`balcony-${num}`}>{num} Balcony{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBalconiesMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBalconiesMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBalconiesMore && (
                                <div className="number-input">
                                    <label>Enter Number of Balconies</label>
                                    <input
                                        type="text"
                                        name="bhk4Balconies"
                                        value={data.bhk4Balconies}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    />
                                </div>
                            )}
                            {errors.bhk4Balconies && <span className="error">This field is required*</span>}
                        </div>

                        {/* Bathrooms Section */}
                        <div className="post-input">
                            <label>Bathrooms</label>
                            <div className="radio-group">
                                {[1, 2, 3].map((num) => (
                                    <div className="radio-option" key={`bathroom-${num}`}>
                                        <input
                                            type="radio"
                                            name="bhk4Bathrooms"
                                            value={num}
                                            id={`bathroom-${num}`}
                                            checked={data.bhk4Bathrooms === String(num)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`bathroom-${num}`}>{num} Bathroom{num > 1 ? "s" : ""}</label>
                                    </div>
                                ))}
                            </div>

                            {!viewBathroomsMore && (
                                <button
                                    type="button"
                                    className="post-view-more-btn"
                                    onClick={() => setViewBathroomsMore(true)}
                                >
                                    View More
                                </button>
                            )}

                            {viewBathroomsMore && (
                                <div className="number-input">
                                    <label>Enter Number of Bathrooms</label>
                                    <input
                                        type="text"
                                        name="bhk4Bathrooms"
                                        value={data.bhk4Bathrooms}
                                        onChange={handleInputChange}
                                        placeholder="Enter custom number"
                                    // min="5"
                                    />
                                </div>
                            )}
                            {errors.bhk4Bathrooms && <span className="error">This field is required*</span>}
                        </div>

                        {/* Furnish Status */}
                        <div className="post-input">
                            <label>Furnish Status</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4FurnishStatus"
                                        value="Furnished"
                                        id="furnish-furnished"
                                        checked={data.bhk4FurnishStatus === "Furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-furnished">Furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4FurnishStatus"
                                        value="Unfurnished"
                                        id="furnish-unfurnished"
                                        checked={data.bhk4FurnishStatus === "Unfurnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-unfurnished">Un-furnished</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4FurnishStatus"
                                        value="Semi-furnished"
                                        id="furnish-semi-furnished"
                                        checked={data.bhk4FurnishStatus === "Semi-furnished"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="furnish-semi-furnished">Semi-furnished</label>
                                </div>
                            </div>
                            {errors.bhk4FurnishStatus && <span className="error">This field is required*</span>}
                        </div>

                        {/* Condition of Flat */}
                        <div className="post-input">
                            <label>Condition of Flat</label>
                            <input
                                type="text"
                                name="bhk4ConditionOfFlat"
                                value={data.bhk4ConditionOfFlat}
                                onChange={handleInputChange}
                                placeholder="Enter condition of flat (Maintenance/Repair)"
                            />
                            {errors.bhk4ConditionOfFlat && <span className="error">This field is required*</span>}
                        </div>


                        {/* Monthly Maintenance */}
                        <div className="post-input">
                            <label>Monthly Maintenance</label>
                            <input
                                type="text"
                                name="bhk4MonthlyMaintenance"
                                value={data.bhk4MonthlyMaintenance}
                                onChange={handleInputChange}
                                placeholder="Enter Monthly Maintenance"
                            />
                            {errors.bhk4MonthlyMaintenance && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price all inclusive</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4PriceAllInclusive"
                                        value="Yes"
                                        id="price-all-inclusive-yes"
                                        checked={data.bhk4PriceAllInclusive === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4PriceAllInclusive"
                                        value="No"
                                        id="price-all-inclusive-no"
                                        checked={data.bhk4PriceAllInclusive === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-all-inclusive-no">No</label>
                                </div>
                            </div>
                            {errors.bhk4PriceAllInclusive && <span className="error">This field is required*</span>}
                        </div>

                        {/* Price Negotiable */}
                        <div className="post-input">
                            <label>Price Negotiable</label>
                            <div className="radio-group">
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4PriceNegotiable"
                                        value="Yes"
                                        id="price-negotiable-yes"
                                        checked={data.bhk4PriceNegotiable === "Yes"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-yes">Yes</label>
                                </div>
                                <div className="radio-option">
                                    <input
                                        type="radio"
                                        name="bhk4PriceNegotiable"
                                        value="No"
                                        id="price-negotiable-no"
                                        checked={data.bhk4PriceNegotiable === "No"}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="price-negotiable-no">No</label>
                                </div>
                            </div>
                            {errors.bhk4PriceNegotiable && <span className="error">This field is required*</span>}
                        </div>

                        {/* Preferred Cash Type */}
                        <div className="post-input">
                            <label>Preferred Cash Type</label>
                            <div className="checkbox-group">
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk4PreferredCashType"
                                        value="Cash"
                                        id="cash-type-cash"
                                        checked={data.bhk4PreferredCashType.includes("Cash")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cash">Cash</label>
                                </div>
                                <div className="checkbox-option">
                                    <input
                                        type="checkbox"
                                        name="bhk4PreferredCashType"
                                        value="Cheque"
                                        id="cash-type-cheque"
                                        checked={data.bhk4PreferredCashType.includes("Cheque")}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor="cash-type-cheque">Cheque</label>
                                </div>
                            </div>
                            {errors.bhk4PreferredCashType && <span className="error">This field is required*</span>}
                        </div>


                        <div className="post-input">
                            <label>Floor plan</label>
                            <input
                                type="file"
                                name="bhk4FloorPlan"
                                accept="image/*"
                                onChange={handleInputChange}
                            />
                            {previews.bhk4FloorPlan && (
                                <div className="image-preview">
                                    <img
                                        src={previews.bhk4FloorPlan}
                                        alt="BHK4 Floor Plan Preview"
                                        style={{ maxWidth: "150px", marginTop: "10px" }}
                                    />
                                </div>
                            )}
                            {errors.bhk4FloorPlan && <span className="error">{errors.bhk4FloorPlan}</span>}
                        </div>
                    </div>
                )}
            </div>
        );
    };


    const handleInputChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
        const maxImageSize = 1024 * 1024;

        if (type === "file") {
            const file = files[0];
            if (file) {
                // Validate file format
                if (!allowedFormats.includes(file.type)) {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        [name]: 'Invalid file format. Only JPG, JPEG, PNG, and WEBP are allowed.',
                    }));
                    return;
                }

                // Validate file size
                if (file.size > maxImageSize) {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        [name]: 'File size should not exceed 1MB.',
                    }));
                    return;
                }

                // Set file preview
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreviews((prevPreviews) => ({
                        ...prevPreviews,
                        [name]: reader.result,
                    }));
                };
                reader.readAsDataURL(file);

                // Update state
                setData((prevState) => ({
                    ...prevState,
                    [name]: file,
                }));

                // Clear error if any
                if (errors[name]) {
                    setErrors((prevErrors) => {
                        const { [name]: removedError, ...rest } = prevErrors;
                        return rest;
                    });
                }
            }
        } else if (type === "checkbox") {
            const updatedArray = checked
                ? [...(data[name] || []), value]
                : (data[name] || []).filter((item) => item !== value);

            setData((prevState) => ({
                ...prevState,
                [name]: updatedArray,
            }));
        } else {
            setData((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }

        // Clear error for non-file inputs
        if (type !== "file" && errors[name]) {
            setErrors((prevErrors) => {
                const { [name]: removedError, ...rest } = prevErrors;
                return rest;
            });
        }
    };


    useEffect(() => {
        fetchAmenities();
        fetchLocationAdvantages();
        fetchCategory();
        fetchSecurityFeature();
        fetchWaterSupply();
    }, []);

    const fetchAmenities = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_LINK}/amenities/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setAmenities(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching amenities:", error);
        }
    };

    const fetchWaterSupply = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_LINK}/water-supply/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setWaterSupply(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching amenities:", error);
        }
    };

    const fetchSecurityFeature = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_LINK}/security/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setSecurity(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching amenities:", error);
        }
    };

    const fetchLocationAdvantages = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_LINK}/location/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setLocationAdvantages(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching location advantages:", error);
        }
    };

    const fetchCategory = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_LINK}/propertycategory/all/${isLoggedIn.user_id}`);
            const activeAmenities = response.data.filter(amenity => amenity.status === 'active');
            setCategory(activeAmenities.reverse());

        } catch (error) {
            console.error('Error fetching amenities:', error);
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoad(false)
        if (validateFields()) {
            const rkDetails = {
                type: "1RK",
                carpetAreas: data.rkCarpetAreas,
                builtUpAreas: data.rkBuiltUpAreas,
                superBuiltUpAreas: data.rkSuperBuiltUpAreas,
                balconies: data.rkBalconies,
                bathrooms: data.rkBathrooms,
                furnishStatus: data.rkFurnishStatus,
                conditionOfFlat: data.rkConditionOfFlat,
                expectedPrice: data.rkExpectedPrices,
                monthlyMaintenance: data.rkMonthlyMaintenance,
                priceAllInclusive: data.rkPriceAllInclusive,
                priceNegotiable: data.rkPriceNegotiable,
                preferredCashType: data.rkPreferredCashType,
                loanFacility: data.rkLoanFacility,
                documentsAvailable: data.rkDocumentsAvailable,
                floorPlan: data.rkFloorPlan,
            };

            const bhk1Details = {
                type: "1BHK",
                carpetAreas: data.bhk1CarpetAreas,
                builtUpAreas: data.bhk1BuiltUpAreas,
                superBuiltUpAreas: data.bhk1SuperBuiltUpAreas,
                bedrooms: data.bhk1Bedrooms,
                balconies: data.bhk1Balconies,
                bathrooms: data.bhk1Bathrooms,
                jodi1: data.bhk1BedroomsJodi1,
                jodi2: data.bhk1BedroomsJodi2,
                furnishStatus: data.bhk1FurnishStatus,
                conditionOfFlat: data.bhk1ConditionOfFlat,
                expectedPrice: data.bhk1ExpectedPrice,
                monthlyMaintenance: data.bhk1MonthlyMaintenance,
                priceAllInclusive: data.bhk1PriceAllInclusive,
                priceNegotiable: data.bhk1PriceNegotiable,
                preferredCashType: data.bhk1PreferredCashType,
                loanFacility: data.bhk1LoanFacility,
                documentsAvailable: data.bhk1DocumentsAvailable,
                floorPlan: data.bhk1FloorPlan,
            };

            const bhk2Details = {
                type: "2BHK",
                carpetAreas: data.bhk2CarpetAreas,
                builtUpAreas: data.bhk2BuiltUpAreas,
                superBuiltUpAreas: data.bhk2SuperBuiltUpAreas,
                bedrooms: data.bhk2Bedrooms,
                jodi1: data.bhk2BedroomsJodi1,
                jodi2: data.bhk2BedroomsJodi2,
                balconies: data.bhk2Balconies,
                bathrooms: data.bhk2Bathrooms,
                furnishStatus: data.bhk2FurnishStatus,
                conditionOfFlat: data.bhk2ConditionOfFlat,
                expectedPrice: data.bhk2ExpectedPrice,
                monthlyMaintenance: data.bhk2MonthlyMaintenance,
                priceAllInclusive: data.bhk2PriceAllInclusive,
                priceNegotiable: data.bhk2PriceNegotiable,
                preferredCashType: data.bhk2PreferredCashType,
                loanFacility: data.bhk2LoanFacility,
                documentsAvailable: data.bhk2DocumentsAvailable,
                floorPlan: data.bhk2FloorPlan,
            };

            const bhk3Details = {
                type: "3BHK",
                carpetAreas: data.bhk3CarpetAreas,
                builtUpAreas: data.bhk3BuiltUpAreas,
                superBuiltUpAreas: data.bhk3SuperBuiltUpAreas,
                bedrooms: data.bhk3Bedrooms,
                jodi1: data.bhk3BedroomsJodi1,
                jodi2: data.bhk3BedroomsJodi2,
                balconies: data.bhk3Balconies,
                bathrooms: data.bhk3Bathrooms,
                furnishStatus: data.bhk3FurnishStatus,
                conditionOfFlat: data.bhk3ConditionOfFlat,
                expectedPrice: data.bhk3ExpectedPrice,
                monthlyMaintenance: data.bhk3MonthlyMaintenance,
                priceAllInclusive: data.bhk3PriceAllInclusive,
                priceNegotiable: data.bhk3PriceNegotiable,
                preferredCashType: data.bhk3PreferredCashType,
                loanFacility: data.bhk3LoanFacility,
                documentsAvailable: data.bhk3DocumentsAvailable,
                floorPlan: data.bhk3FloorPlan,
            };

            const bhk4Details = {
                type: "4BHK",
                carpetAreas: data.bhk4CarpetAreas,
                builtUpAreas: data.bhk4BuiltUpAreas,
                superBuiltUpAreas: data.bhk4SuperBuiltUpAreas,
                bedrooms: data.bhk4Bedrooms,
                jodi1: data.bhk4BedroomsJodi1,
                jodi2: data.bhk4BedroomsJodi2,
                balconies: data.bhk4Balconies,
                bathrooms: data.bhk4Bathrooms,
                furnishStatus: data.bhk4FurnishStatus,
                conditionOfFlat: data.bhk4ConditionOfFlat,
                expectedPrice: data.bhk4ExpectedPrice,
                monthlyMaintenance: data.bhk4MonthlyMaintenance,
                priceAllInclusive: data.bhk4PriceAllInclusive,
                priceNegotiable: data.bhk4PriceNegotiable,
                preferredCashType: data.bhk4PreferredCashType,
                loanFacility: data.bhk4LoanFacility,
                documentsAvailable: data.bhk4DocumentsAvailable,
                floorPlan: data.bhk4FloorPlan,
            };
            const formDataPayload = new FormData();
            const flatTypeData = [
                {
                    ...rkDetails,
                    floorPlan: data.rkFloorPlan ? data.rkFloorPlan.name : null,
                },
                {
                    ...bhk1Details,
                    floorPlan: data.bhk1FloorPlan ? data.bhk1FloorPlan.name : null,
                },
                {
                    ...bhk2Details,
                    floorPlan: data.bhk2FloorPlan ? data.bhk2FloorPlan.name : null,
                },
                {
                    ...bhk3Details,
                    floorPlan: data.bhk3FloorPlan ? data.bhk3FloorPlan.name : null,
                },
                {
                    ...bhk4Details,
                    floorPlan: data.bhk4FloorPlan ? data.bhk4FloorPlan.name : null,
                },
            ];

            formDataPayload.append("flatType", JSON.stringify(flatTypeData));
            formDataPayload.append("building_name", data.building_name);
            formDataPayload.append("address", data.address);
            formDataPayload.append("city", data.city);
            formDataPayload.append("user_id", isLoggedIn.user_id);
            formDataPayload.append("amenities", JSON.stringify(selectedAmenities));
            formDataPayload.append("totalFloors", data.totalFloors);
            formDataPayload.append("floorLevel", data.floorLevel);
            formDataPayload.append("availability", availabilityStatus);
            formDataPayload.append("ageOfBuilding", data.ageOfBuilding);
            formDataPayload.append("possesionTill", data.possesionTill);
            formDataPayload.append("under_construction", data.under_construction);
            formDataPayload.append("ownership", data.ownership);
            formDataPayload.append("facing", data.facing);
            formDataPayload.append("brokage", data.brokage);
            formDataPayload.append("parking", data.parking);
            formDataPayload.append("booking_amount", data.securityDeposit);
            formDataPayload.append("locationAdvantage", JSON.stringify(selectedLocationAdvantages));
            formDataPayload.append("water_supply", JSON.stringify(selectedWaterSupply));
            formDataPayload.append("security", JSON.stringify(selectedsecurity));
            formDataPayload.append("virtual_tour", data.virtualTour);
            formDataPayload.append("developer_name", data.developerName);
            formDataPayload.append("developer_description", data.developerDescription);
            formDataPayload.append("property_description", data.propertyDescription);
            // formDataPayload.append("jodi1", data.jodi1);
            // formDataPayload.append("jodi2", data.jodi2);
            // formDataPayload.append("bathrooms", data.bathrooms);
            // formDataPayload.append("developerName", data.developerName);
            // formDataPayload.append("developerDescription", data.developerDescription);
            // formDataPayload.append("propertyDescription", data.propertyDescription);
            // formDataPayload.append("balconies", data.balconies);
            // formDataPayload.append("availability", data.availability);

            // formDataPayload.append("ownership", data.ownership);
            // formDataPayload.append("facing", data.facing);
            // formDataPayload.append("maintenance", data.maintenance);
            // formDataPayload.append("parking", data.parking);
            // formDataPayload.append("securityDeposit", data.securityDeposit);

            // formDataPayload.append("furnishStatus", data.furnishStatus);
            // formDataPayload.append("category", data.category);
            // formDataPayload.append("extra2", data.extra2);


            if (data.floorPlan) {
                formDataPayload.append("floorPlan", data.floorPlan); // Match the backend field name
            }
            if (data.dev_logo) {
                formDataPayload.append("dev_logo", data.dev_logo); // Match the backend field name
            }


            uploadedFiles.forEach((image, index) => {
                formDataPayload.append(`formImages`, image); // Ensure formImages are appended correctly
            });


            if (data.rkFloorPlan) {
                formDataPayload.append("rkFloorPlan", data.rkFloorPlan, data.rkFloorPlan.name);
            }
            if (data.bhk1FloorPlan) {
                formDataPayload.append("bhk1FloorPlan", data.bhk1FloorPlan, data.bhk1FloorPlan.name);
            }
            if (data.bhk2FloorPlan) {
                formDataPayload.append("bhk2FloorPlan", data.bhk2FloorPlan, data.bhk2FloorPlan.name);
            }
            if (data.bhk3FloorPlan) {
                formDataPayload.append("bhk3FloorPlan", data.bhk3FloorPlan, data.bhk3FloorPlan.name);
            }
            if (data.bhk4FloorPlan) {
                formDataPayload.append("bhk4FloorPlan", data.bhk4FloorPlan, data.bhk4FloorPlan.name);
            }

            try {
                const response = await fetch(`${url}/resident/add-property`, {
                    method: "POST",
                    body: formDataPayload,
                });
                const result = await response.json();
                if (response.ok) {

                    alert('Property Added successfully!');
                    navigate(`/`)
                    setLoad(true);
                    setData({
                        building_name: "",
                        address: "",
                        city: "",
                        floorPlan: "",
                        flatType: [],
                        carpetArea: [{ carpetArea: "", price: "" }],
                        buildupArea: "",
                        totalFloors: "",
                        floorLevel: "",
                        bedrooms: "",
                        bathrooms: "",
                        balconies: "",
                        availability: "",
                        ageOfBuilding: "",
                        possesionTill: "",
                        ownership: "",
                        facing: "",
                        maintenance: "",
                        parking: "",
                        securityDeposit: "",
                        virtualTour: "",
                        furnishStatus: "",
                        category: "",

                        rkCarpetAreas: [{ value: "", showMinus: false }],
                        rkBuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
                        rkSuperBuiltUpAreas: [{ value: "", showMinus: false }],
                        rkExpectedPrices: [{ value: '' }],
                        rkBalconies: '',
                        rkBathrooms: '',
                        rkFurnishStatus: '',
                        rkConditionOfFlat: '',
                        rkMonthlyMaintenance: '',
                        rkPriceAllInclusive: '',
                        rkPriceNegotiable: '',
                        rkPreferredCashType: [],
                        rkLoanFacility: '',
                        rkDocumentsAvailable: '',
                        rkFloorPlan: '',

                        // 1BHK-specific fields
                        bhk1CarpetAreas: [{ value: "", showMinus: false }],
                        bhk1BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
                        bhk1SuperBuiltUpAreas: [{ value: "", showMinus: false }],
                        bhk1ExpectedPrices: [{ value: '' }],
                        bhk1Bedrooms: '',
                        bhk1BedroomsJodi1: '',
                        bhk1BedroomsJodi2: '',
                        bhk1Balconies: '',
                        bhk1Bathrooms: '',
                        bhk1FurnishStatus: '',
                        bhk1ConditionOfFlat: '',
                        bhk1MonthlyMaintenance: '',
                        bhk1PriceAllInclusive: '',
                        bhk1PriceNegotiable: '',
                        bhk1PreferredCashType: [],
                        bhk1LoanFacility: '',
                        bhk1DocumentsAvailable: '',
                        bhk1FloorPlan: '',

                        bhk2CarpetAreas: [{ value: "", showMinus: false }],
                        bhk2BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
                        bhk2SuperBuiltUpAreas: [{ value: "", showMinus: false }],
                        bhk2ExpectedPrices: [{ value: '' }],
                        bhk2Bedrooms: '',
                        bhk2BedroomsJodi1: '',
                        bhk2BedroomsJodi2: '',
                        bhk2Balconies: '',
                        bhk2Bathrooms: '',
                        bhk2FurnishStatus: '',
                        bhk2ConditionOfFlat: '',
                        bhk2MonthlyMaintenance: '',
                        bhk2PriceAllInclusive: '',
                        bhk2PriceNegotiable: '',
                        bhk2PreferredCashType: [],
                        bhk2LoanFacility: '',
                        bhk2DocumentsAvailable: '',
                        bhk2FloorPlan: '',

                        bhk3CarpetAreas: [{ value: "", showMinus: false }],
                        bhk3BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
                        bhk3SuperBuiltUpAreas: [{ value: "", showMinus: false }],
                        bhk3ExpectedPrices: [{ value: '' }],
                        bhk3Bedrooms: '',
                        bhk3BedroomsJodi1: '',
                        bhk3BedroomsJodi2: '',
                        bhk3Balconies: '',
                        bhk3Bathrooms: '',
                        bhk3FurnishStatus: '',
                        bhk3ConditionOfFlat: '',
                        bhk3MonthlyMaintenance: '',
                        bhk3PriceAllInclusive: '',
                        bhk3PriceNegotiable: '',
                        bhk3PreferredCashType: [],
                        bhk3LoanFacility: '',
                        bhk3DocumentsAvailable: '',
                        bhk3FloorPlan: '',

                        bhk4CarpetAreas: [{ value: "", showMinus: false }],
                        bhk4BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
                        bhk4SuperBuiltUpAreas: [{ value: "", showMinus: false }],
                        bhk4ExpectedPrices: [{ value: '' }],
                        bhk4Bedrooms: '',
                        bhk4BedroomsJodi1: '',
                        bhk4BedroomsJodi2: '',
                        bhk4Balconies: '',
                        bhk4Bathrooms: '',
                        bhk4FurnishStatus: '',
                        bhk4ConditionOfFlat: '',
                        bhk4MonthlyMaintenance: '',
                        bhk4PriceAllInclusive: '',
                        bhk4PriceNegotiable: '',
                        bhk4PreferredCashType: [],
                        bhk4LoanFacility: '',
                        bhk4DocumentsAvailable: '',
                        bhk4FloorPlan: '',
                    })
                } else {
                    setLoad(true);
                    toast.error(result.message);
                }
            } catch (error) {
                setLoad(true);
                toast.error(error);

            }
        } else {
            setLoad(true);
            toast.error("Form has errors:", errors);

        }
    };


    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <form className="property-form" onSubmit={handleSubmit}>
                    <div className="oms-header">
                        <h1 className="dashboard-title">Resident Form</h1>
                        <Link to="/" className="dashboard-p-form">
                            View Properties
                        </Link>
                    </div>
                    <div>
                        <label>Building/Project Name</label>
                        <input type="text" name="building_name" value={data.building_name} onChange={handleInputChange} placeholder="Enter Building/Project Name" />
                    </div>
                    <div>
                        <label>Address</label>
                        <input type="text" name="address" value={data.address} onChange={handleInputChange} placeholder="Enter Full Address" />
                    </div>
                    <div>
                        <label>City</label>
                        <input type="text" name="city" value={data.city} onChange={handleInputChange} placeholder="Enter City" />
                    </div>
                    <div className="location">
                        <div>
                            <label>Amenities</label>
                            <div className="button-group">
                                {amenities.map((amenity) => (
                                    <button
                                        type="button"
                                        key={amenity.id}
                                        className={`toggle-button ${selectedAmenities.includes(amenity.name) ? "selected" : ""
                                            }`}
                                        onClick={() => toggleAmenity(amenity.name)}
                                    >
                                        {amenity.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="form-container">
                        <div className="post-input">
                            <label>Flat Type</label>
                            <div className="checkbox-group">
                                {["1RK", "1BHK", "2BHK", "3BHK", "4BHK"].map((type) => (
                                    <div className="checkbox-option" key={type}>
                                        <input
                                            type="checkbox"
                                            name="flatType"
                                            value={type}
                                            id={`flattype-${type}`}
                                            checked={data.flatType.includes(type)}
                                            onChange={handleInputChange}
                                        />
                                        <label htmlFor={`flattype-${type}`}>{type}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        {data.flatType.includes("1RK") && render1RKSection()}
                        {data.flatType.includes("1BHK") && render1BHKSection()}
                        {data.flatType.includes("2BHK") && render2BHKSection()}
                        {data.flatType.includes("3BHK") && render3BHKSection()}
                        {data.flatType.includes("4BHK") && render4BHKSection()}
                    </div>
                    <div>
                        <label>Total Number of Floors</label>
                        <input type="text" name="totalFloors" value={data.totalFloors} onChange={handleInputChange} placeholder="Enter Total Number of Floors" />
                    </div>
                    <div>
                        <label>Floor Number</label>
                        <input type="text" name="floorLevel" value={data.floorLevel} onChange={handleInputChange} placeholder="Enter Floor Number (e.g., 1, 2, etc.)" />
                    </div>
                    <div className="radio-group">
                        <label>Availability Status</label>
                        <input
                            type="radio"
                            id="availability-ready"
                            name="availability"
                            value="Ready to Move"
                            checked={availabilityStatus === "Ready to Move"}
                            onChange={() => setAvailabilityStatus("Ready to Move")}
                        />
                        <label htmlFor="availability-ready">Ready to Move</label>
                        <input
                            type="radio"
                            id="availability-under"
                            name="availability"
                            value="Under Construction"
                            checked={availabilityStatus === "Under Construction"}
                            onChange={() => setAvailabilityStatus("Under Construction")}
                        />
                        <label htmlFor="availability-under">Under Construction</label>
                    </div>
                    {availabilityStatus === "Ready to Move" ? (
                        <div className='margin-top-10px-oms-div'>
                            <label>Age of Building (years)</label>
                            <input type="text" name="ageOfBuilding" placeholder="Enter Age of Building" value={data.ageOfBuilding} onChange={handleInputChange} />
                        </div>
                    ) : (
                        <div className='margin-top-10px-oms-div'>
                            <label>Possession Till</label>
                            <input type="date" name="possesionTill" placeholder="Select Possession Date" value={data.possesionTill} onChange={handleInputChange} />
                        </div>
                    )}
                    <div className="radio-group">
                        <label>Ownership</label>
                        <input type="radio" id="ownership-freehold" name="ownership" value="freehold" onChange={handleInputChange} />
                        <label htmlFor="ownership-freehold">Freehold</label>
                        <input type="radio" id="ownership-leasehold" name="ownership" value="leasehold" onChange={handleInputChange} />
                        <label htmlFor="ownership-leasehold">Leasehold</label>
                        <input type="radio" id="ownership-SRA-Redevelopment" name="ownership" value="SRA-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="ownership-SRA-Redevelopment">SRA Redevelopment</label>
                        <input type="radio" id="ownership-Society-Redevelopment" name="ownership" value="Society-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="ownership-Society-Redevelopment">Society Redevelopment</label>
                        <input type="radio" id="ownership-MHADA-Redevelopment" name="ownership" value="MHADA-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="ownership-MHADA-Redevelopment">MHADA Redevelopment</label>
                        <input type="radio" id="ownership-BMC-Redevelopment" name="ownership" value="BMC-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="ownership-BMC-Redevelopment">BMC Redevelopment</label>
                    </div>
                    <div className="radio-group">
                        <label className='margin-top-10px-oms-div'>Facing Direction</label>
                        <input type="radio" id="facing-north" name="facing" value="north" onChange={handleInputChange} />
                        <label htmlFor="facing-north">North</label>
                        <input type="radio" id="facing-south" name="facing" value="south" onChange={handleInputChange} />
                        <label htmlFor="facing-south">South</label>
                        <input type="radio" id="facing-east" name="facing" value="east" onChange={handleInputChange} />
                        <label htmlFor="facing-east">East</label>
                        <input type="radio" id="facing-west" name="facing" value="west" onChange={handleInputChange} />
                        <label htmlFor="facing-west">West</label>
                    </div>

                    <div className="radio-group">
                        <label className="margin-top-10px-oms-div">Brokage</label>

                        <input
                            type="radio"
                            id="brokage-yes"
                            name="brokage"
                            value="yes"
                            onChange={handleInputChange}
                        />
                        <label htmlFor="brokage-yes">Yes</label>

                        <input
                            type="radio"
                            id="brokage-no"
                            name="brokage"
                            value="no"
                            onChange={handleInputChange}
                        />
                        <label htmlFor="brokage-no">No</label>
                    </div>
                    <div className='margin-top-10px-oms-div'>
                        <label>Parking</label>
                        <input type="text" name="parking" placeholder="Enter Number of Parking Slots" value={data.parking} onChange={handleInputChange} />
                    </div>
                    <div>
                        <label>Booking Amount(₹)</label>
                        <input type="text" name="securityDeposit" placeholder="Enter Booking Amount" value={data.securityDeposit} onChange={handleInputChange} />
                    </div>
                    <div className="location">
                        <div>
                            <label>Location Advantages</label>
                            <div className="button-group">
                                {locationAdvantages.map((advantage) => (
                                    <button
                                        type="button"
                                        key={advantage.id}
                                        className={`toggle-button ${selectedLocationAdvantages.includes(advantage.name)
                                            ? "selected"
                                            : ""
                                            }`}
                                        onClick={() => toggleLocationAdvantage(advantage.name)}
                                    >
                                        {advantage.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="location">
                        <div>
                            <label>Water Supply</label>
                            <div className="button-group">
                                {watersupply.map((advantage) => (
                                    <button
                                        type="button"
                                        key={advantage.id}
                                        className={`toggle-button ${selectedWaterSupply.includes(advantage.name)
                                            ? "selected"
                                            : ""
                                            }`}
                                        onClick={() => toggleWaterSupply(advantage.name)}
                                    >
                                        {advantage.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="location">
                        <div>
                            <label>Security</label>
                            <div className="button-group">
                                {security.map((advantage) => (
                                    <button
                                        type="button"
                                        key={advantage.id}
                                        className={`toggle-button ${selectedsecurity.includes(advantage.name)
                                            ? "selected"
                                            : ""
                                            }`}
                                        onClick={() => toggleSecurity(advantage.name)}
                                    >
                                        {advantage.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div>
                        <label>Virtual Tour (URL)</label>
                        <input type="text" name="virtualTour" placeholder="Enter Virtual Tour URL" value={data.virtualTour} onChange={handleInputChange} />
                    </div>
                    {/* <div className="radio-group">
                        <label>Property Category</label>
                        {
                            category.map((ele, idx) => (
                                <React.Fragment key={idx}>
                                    <input
                                        type="radio"
                                        id={`category-${ele.name}`}
                                        name="category"
                                        value={ele.name}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor={`category-${ele.name}`}>{ele.name}</label>
                                </React.Fragment>
                            ))
                        }
                    </div> */}
                    <div className="margin-top-10px-oms-div">
                        <label>Developer Logo</label>
                        <input
                            type="file"
                            name="dev_logo"
                            accept="image/*"
                            onChange={handleInputChange}
                        />
                        {previews.dev_logo && (
                            <div className="image-preview">
                                <img
                                    src={previews.dev_logo}
                                    alt="Developer Logo Preview"
                                    style={{ maxWidth: "150px", marginTop: "10px" }}
                                />
                            </div>
                        )}
                        {errors.dev_logo && <span className="error">{errors.dev_logo}</span>}
                    </div>

                    <div>
                        <label>Developer Name</label>
                        <input
                            type="text"
                            name="developerName"
                            placeholder="Enter Developer Name"
                            value={data.developerName}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div>
                        <label>Developer Description</label>
                        <input
                            type='text'
                            name="developerDescription"
                            placeholder="Enter Developer Description"
                            value={data.developerDescription}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div>
                        <label>Property Description</label>
                        <input
                            type='text'
                            name="propertyDescription"
                            placeholder="Enter Property Description"
                            value={data.propertyDescription}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="post-property-image">
                        <p className="post-property-image-head">Upload your image</p>
                        <p className="post-property-limits">
                            You can upload up to 20 images, with a total size limit of 20MB, in JPG or JPEG format.
                        </p>

                        <div
                            className={`post-property-image-container ${dragging ? 'dragging' : ''}`}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                        >
                            <i className="fa-solid fa-arrow-up-from-bracket"></i>
                            <p>Drag and drop your images or</p>
                            <button className="browse-files" onClick={handleBrowseClick}>
                                Browse images
                            </button>
                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                multiple
                                accept=".jpg, .jpeg, .webp, .png"
                                onChange={handleFileChange}
                            />
                        </div>

                        <div className="upload-file-container">
                            {uploadedFiles.length > 0 ? (
                                <>
                                    <p className="upload-file-head">Uploaded Files:</p>

                                    <ul className="upload-file-list">
                                        {uploadedFiles.map((file, index) => {
                                            const tooLarge = file.size > 1024 * 1024;
                                            return (
                                                <li
                                                    key={index}
                                                    className={`upload-file-item ${tooLarge ? 'file-too-large' : ''}`}
                                                >
                                                    <span>{file.name} ({formatFileSize(file.size)})</span>
                                                    <button
                                                        className="delete-file-btn"
                                                        onClick={() => handleDeleteFile(index)}
                                                    >
                                                        <i className="fa-solid fa-xmark"></i>
                                                    </button>
                                                </li>
                                            );
                                        })}
                                    </ul>

                                    {/* Optional: Thumbnail previews */}
                                    <div className="image-gallery">
                                        {uploadedFiles.map((file, index) => (
                                            <div key={index} className="image-container">
                                                <img
                                                    src={URL.createObjectURL(file)}
                                                    alt={`Preview ${index + 1}`}
                                                    className="property-image"
                                                />
                                            </div>
                                        ))}
                                    </div>

                                    {uploadedFiles.some(file => file.size > 1024 * 1024) && (
                                        <p className="file-error-text">Remove files that exceed 1MB</p>
                                    )}
                                </>
                            ) : (
                                <p className="no-files-message">No files uploaded yet.</p>
                            )}
                        </div>
                    </div>

                    {
                        load ? <button type="submit" className='post-property-submit'>Submit</button> :
                            <button type="button" className='post-property-submit' disabled>Loading...</button>
                    }

                </form>
            </div>
        </>
    );
};

export default ResidentPropertyForm;